import React, { useContext } from 'react'
import classNames from 'classnames'
import { FlexColumn } from '@/atoms/FlexContainers'
import { CircleStarIcon } from '@/atoms/Icons/CircleStarIcon'
import { AsP, EyebrowSM, EyebrowXS, HeadingXS } from '@/atoms/Text'
import { useSafeTrack } from '@/utils/analytics'
import { useTranslate } from '@/utils/translate/translate-client'
import { LimitedDateModalContext } from '@/views/TicketCheckoutViews/ShowtimesView/contexts/LimitedDateModalContext'
import { useTicketsContext } from '../TicketsContext'

interface Props {
  eventDate: Date | null
}

export const LimitedDateCard: React.FC<Props> = ({ eventDate }) => {
  const limitedDateModalContext = useContext(LimitedDateModalContext)
  const track = useSafeTrack()
  const { t } = useTranslate('tickets')
  const { experiments } = useTicketsContext()

  if (!eventDate) return null

  const month = eventDate.toLocaleDateString('en-US', { month: 'short' }).toUpperCase()
  const day = eventDate.getDate()

  const handleClick = () => {
    track('Limited Date Card Clicked')
    limitedDateModalContext.openModal()
  }

  const cardVariant = experiments?.['premiere_card'] ?? 'control'

  if (cardVariant === 'hidden') {
    return null
  }

  return (
    <div
      className={classNames('relative h-24 w-[72px] cursor-pointer overflow-hidden rounded-xl hover:scale-105', {
        'bg-[#F00] bg-limited-date-card': cardVariant === 'control',
        'bg-error-100 border-[1.5px] border-error-600': cardVariant === 'outline',
      })}
      onClick={handleClick}
    >
      <FlexColumn className="relative h-full items-center justify-center">
        <CircleStarIcon
          size={16}
          className="absolute right-1 top-1"
          color={cardVariant === 'outline' ? 'error-700' : 'white'}
        />
        <div
          className={classNames('flex h-full flex-col justify-center p-1 text-center', {
            'text-error-700': cardVariant === 'outline',
            'text-white': cardVariant === 'control',
          })}
        >
          <EyebrowSM className="cursor-pointer">{month}</EyebrowSM>
          <HeadingXS as={AsP} weight="bold">
            {day}
          </HeadingXS>
          <EyebrowXS weight="normal" className="cursor-pointer uppercase">
            {t('guildOnlyRedCarpet', 'Guild Only Red Carpet')}
          </EyebrowXS>
        </div>
      </FlexColumn>
    </div>
  )
}
